import { User, Clock, CheckCircle2 } from "lucide-react";

const STATUS_COLOR = {
  available:  "#10b981",
  cleaning:   "#f59e0b",
  inspecting: "#38bdf8",
  break:      "#a78bfa",
  off_duty:   "#64748b",
};

export default function StaffCard({ attendant, bucket, onDragStart }) {
  const color = STATUS_COLOR[bucket] || "#64748b";
  const initials = (attendant.name || "?")
    .split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

  return (
    <div
      draggable={bucket === "available" || bucket === "break"}
      onDragStart={(e) => onDragStart?.(e, attendant)}
      data-testid={`staff-card-${attendant.attendant_id}`}
      className="group rounded-xl bg-white/[0.05] hover:bg-white/[0.10] border border-white/[0.14] p-3 cursor-grab active:cursor-grabbing transition-colors"
    >
      <div className="flex items-center gap-2.5 mb-2">
        <div className="w-8 h-8 rounded-lg flex items-center justify-center text-[11px] font-bold text-white shrink-0"
          style={{ background: color, boxShadow: `0 0 12px ${color}66` }}>
          {initials}
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[12.5px] font-semibold text-white truncate">{attendant.name}</div>
          <div className="text-[10.5px] text-white/60 truncate">{attendant.employee_id || attendant.email}</div>
        </div>
      </div>
      {attendant.current_room && (
        <div className="text-[11px] text-white flex items-center gap-1.5">
          <span className="text-white/70">Room</span>
          <span className="font-semibold text-white tabular-nums">{attendant.current_room}</span>
        </div>
      )}
      <div className="grid grid-cols-2 gap-1.5 mt-2 text-[10px]">
        <div className="flex items-center gap-1 text-white/80">
          <CheckCircle2 className="w-3 h-3 text-emerald-300"/>
          <span className="tabular-nums font-semibold">{attendant.rooms_completed_today}</span>
          <span className="text-white/50">done</span>
        </div>
        {attendant.current_timer_min != null && (
          <div className="flex items-center gap-1 text-white/80">
            <Clock className="w-3 h-3 text-amber-300"/>
            <span className="tabular-nums font-semibold">{Math.round(attendant.current_timer_min)}m</span>
          </div>
        )}
        {attendant.avg_cleaning_time_min > 0 && (
          <div className="flex items-center gap-1 text-white/70 col-span-2">
            <User className="w-3 h-3"/>
            <span className="tabular-nums">Avg {attendant.avg_cleaning_time_min}m</span>
          </div>
        )}
      </div>
    </div>
  );
}
